// extracted by mini-css-extract-plugin
module.exports = {"link":"EmailLink_link__2rXUP","linkNoStyle":"EmailLink_linkNoStyle__2b5on"};